import classNames from "classnames"
import { ReactNode } from "react"

export type BadgeVariant =
  | "info"
  | "success"
  | "attention"
  | "critical"
  | "primary"
  | "secondary"
  | "tertiary"
  | "disabled"
  | "neutral"
interface Props {
  className?: string
  children: ReactNode
  variant: BadgeVariant
}

export function Badge({ children, className, variant }: Props) {
  return (
    <span
      className={classNames("capitalize py-1 px-3 rounded-full", className, {
        "bg-[color:var(--alias-color-bg-info)]": variant === "info",
        "bg-[color:var(--alias-color-bg-success)]": variant === "success",
        "bg-[color:var(--alias-color-bg-attention)]": variant === "attention",
        "bg-[color:var(--alias-color-bg-critical)]": variant === "critical",
        "bg-[color:var(--alias-color-bg-primary)]": variant === "primary",
        "bg-[color:var(--alias-color-bg-secondary)]": variant === "secondary",
        "bg-[color:var(--alias-color-bg-tertiary)]": variant === "tertiary",
        "bg-[color:var(--alias-color-bg-disabled)]": variant === "disabled",
        "bg-[color:var(--alias-color-bg-neutral)]": variant === "neutral",
      })}
    >
      {children}
    </span>
  )
}
